"use client";
import { useEffect, useState } from 'react';
import { Search } from './Search';

type ModuleData = { slug: string; title?: string };
type ScenarioData = { slug: string; title: string };

export function SearchDataProvider() {
    const [modules, setModules] = useState<ModuleData[]>([]);
    const [scenarios, setScenarios] = useState<ScenarioData[]>([]);

    useEffect(() => {
        import('../src/data/curriculum.json').then((mod: { default: { modules: string[] } }) => {
            setModules((mod.default.modules || []).map(slug => ({ slug })));
        });
        fetch('/data/scenarios/index.json')
            .then(r => (r.ok ? r.json() : []))
            .then(setScenarios)
            .catch(() => setScenarios([]));
    }, []);

    return <Search modules={modules} scenarios={scenarios} />;
}


